<template>
  <div
    id="contentwrapper"
    :style="{ 'margin-bottom': bottommargin }"
    :class="{ headerbig: isScrollonTop, headersmall: !isScrollonTop }"
  >
    <div
      id="waitmodal"
      class="modal in vue-modal"
      :class="{ 'vue-modal-fade-enter': !loadingBar.showwaiter, 'vue-modal-active': loadingBar.showwaiter }"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      aria-hidden="false"
      style="display: block"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="waiter">
              <span>{{ translation(4424) }}</span>
              <div>
                <img src="/images/waiter.gif" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="vueloadlabelholder">
      <fade-transition :duration="{ enter: 200, leave: 1000 }">
        <div id="vueloadlabel" v-show="loadingBar.vueloadedlabelanim">
          <div id="vueloadinglabel" v-show="loadingBar.vueloadinglabel">{{ loadingBar.loadingMessage }}</div>
          <div id="vueloadedlabel" v-show="loadingBar.vueloadedlabel">{{ loadingBar.loadedMessage }}</div>
        </div>
      </fade-transition>
    </div>
    <vue-progress-bar></vue-progress-bar>

    <div
      id="PEwrapper"
      class="Bootstrapcss parentFixed"
      :style="{ paddingTop: fixedcontainerHeight }"
      :class="{
        disableMenu: menuOptions.disableMenu,
        menuNotLoaded: !menuOptions.loadMenu,
        menuLoaded: menuOptions.loadMenu,
      }"
    >
      <div id="fixedcontainer">
        <div v-resize.initial="onResize">
          <XVmenu :menuOptions="menuOptions" v-if="menuOptions.loadTopbanner"></XVmenu>
          <!-- oude FAContainer   stond hier   -->
          <div v-if="isDotnetPage">
            <XVactionbar></XVactionbar>
          </div>
          <portal-target name="actionbar" slim></portal-target>
        </div>
      </div>
      <XVnotifications></XVnotifications>
      <transition name="fade">
        <div v-if="!isDotnetPage" id="contentdiv" class="contentDiv BootmenuClosed">
          <router-view :key="$route.path"></router-view>
          <!-- hier staat de inhoud van de pagina -->
        </div>
      </transition>
    </div>

    <div id="fullpageerrormessage" style="text-align: center" :class="errorshow">
      <div v-if="!custErrorShow">
        <h1 class="text-center">{{ translation(14382) }}</h1>
        <h4 class="text-center">{{ translation(14383) }}</h4>
      </div>
      <div v-if="custErrorShow">
        <h1 class="text-center">{{ translation(14590) }}</h1>
        <h4 class="text-center">{{ custError }}</h4>
      </div>
      <div>
        <span @click="reload()" class="pointer fakelink">
          <font-awesome-icon :icon="['fa', 'sync-alt']" size="lg" />
          {{ translation(14591) }}
        </span>
      </div>
    </div>
    <div id="actionsbuttonsMobileMenu" v-if="statusMobileMenu === 2">
      <a class="actionsbtnMobileMenu" :href="userInfo.mailurl" @click="setstatusMobileMenu(statusMobileMenu)">
        <font-awesome-layers class="fa-lg">
          <font-awesome-icon :icon="['fal', 'envelope']" />
          <font-awesome-icon
            icon="circle"
            transform="shrink-10 right-7 up-4"
            v-if="userInfo.messagesUnread != 0"
            class="mailreddot"
          />
        </font-awesome-layers>
      </a>
      <a v-if="userInfo.logouturl != ''" :href="userInfo.logouturl" @click="Logout()" class="actionsbtnMobileMenu">
        <font-awesome-icon :icon="['fal', 'sign-out']" />
      </a>
    </div>
  </div>
</template>
<script>
import { util, EventBus, FAMixin } from 'pevueglobal'
import { FadeTransition } from 'vue2-transitions'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import locStore from 'store2'
import resize from 'vue-resize-directive'
import bootstrapMediaQuery from '../modules/mixins/vue-media-query-mixin/bootstrap-media-query'
export default {
  name: 'contentwrapper',
  directives: {
    resize,
  },
  data: function () {
    return {
      errorshow: 'hide',
      showpdfframe: false,
      pdfurl: util.createApiUrl('/public/pdfviewer/loading.html'),
      custError: '',
      custErrorShow: false,
      isDotnetPage: PEGLOBALS.DotnetPage,
      foundActionbuttons: false,
      isloading: false,
      fixedcontainerHeight: 0,
      bottommargin: 0,
    }
  },
  mounted: async function () {
    this.$store.watch(
      (state, getters) => state.loadingBar.isloading,
      (newValue, oldValue) => {
        if (newValue) {
          this.$Progress.start()
        } else {
          this.$Progress.finish()
        }
      }
    )

    let jsongritter = util.UgetCookie('jsongritter')
    if (jsongritter !== '') {
      jsongritter = decodeURI(jsongritter) // nodig om de spaties (%20) nog om te zetten, de rest gebeurt al in UgetCookie die decodeURIComponent aanroept in utils.js

      let jgp = JSON.parse(jsongritter)
      this.addNotification({
        groupname: jgp.className.replace('gritter-', ''),
        message: jgp.message,
        sticky: jgp.sticky,
        title: jgp.title,
      })

      util.UsetCookie('jsongritter', '')
    }
    this.$validator.localize(util.GetCulture().split('-')[0]) // set de validator local settings voor veelidate

    if (PEGLOBALS.DotnetPage) {
      $('#contentdiv').detach().appendTo('#PEwrapper')
      this.setMenuOptions(PEGLOBALS.menuOptions)
      // console.log(PEGLOBALS.menuOptions)
    }
    // voor splash page peapp
    $('.splash').addClass('fadeout')

    // $('html').css('overflow', 'auto')
    $('html').css('background-color', '#ffffff')
    await this.getInitData()
    window.addEventListener(
      'scroll',
      util.debounced(200, () => {
        this.setScrollOnTop($(document).scrollTop() === 0)
        if (this.isScrollonTop === false) {
          this.bottommargin = '100px'
        }
      })
    )

    EventBus.$on('apperror', (customerError) => {
      if (customerError !== 0) {
        this.custErrorShow = true
        this.custError = this.translation(customerError)
      }

      this.errorshow = ''
    })

    EventBus.$on('mailcheck', (filter) => {
      this.checkmail()
    })
    // EventBus.$on('updateProgressbar', event => {
    //   if (event === 'start') {
    //     this.$Progress.start()
    //     console.log('start')
    //   } else {
    //     this.$Progress.finish()
    //     console.log('finish')
    //   }
    // })

    // detect profgroup change so we can clear the browser localstorage
    if (locStore.session('pe_activeProfGroup') === null || locStore.session('pe_activeProfGroup') === '') {
      locStore.session('pe_activeProfGroup', util.UgetCookie('pe_activeProfGroup'))
    } else {
      if (locStore.session('pe_activeProfGroup') !== util.UgetCookie('pe_activeProfGroup')) {
        // letop dit is dus niet de VUE store, maar browser storage https://github.com/nbubna/store
        // En active profgroup vullen met de huidige.
        locStore.session.remove('WarningID1001') // haal WarningID1001 uit session store zodat gritter voor nieuwe berichten opnieuw getoond word, andere mledingen moeten niet meer getoond worden
        locStore.session('pe_activeProfGroup', util.UgetCookie('pe_activeProfGroup'))
      }
    }
    if (PEGLOBALS.DotnetPage) {
      this.stopLoading()
    }
  },
  methods: {
    async onResize() {
      // deze resize gebeurd alleen als de fixedcontainer div groter of kleiner word, (resize page, actionbar on/off, big smallheader etc)
      await this.$nextTick()
      this.fixedcontainerHeight = $('#fixedcontainer').height() + 'px'
      this.setFixedContainerHeight(this.fixedcontainerHeight)
      util.debounced(3000, this.setmq())
    },
    reload() {
      location.reload()
    },
    ...mapActions(['getInitData', 'checkmail', 'Logout']),
    ...mapMutations([
      'setstatusMobileMenu',
      'setScrollOnTop',
      'setMediaQuery',
      'setMenuOptions',
      'setFixedContainerHeight',
      'stopLoading',
      'addNotification',
    ]),
    showJumpMenu() {
      return PEGLOBALS.DotnetPage || (!PEGLOBALS.DotnetPage && this.jumpmenuitems.length > 0)
    },
    setmq(event) {
      let w = document.documentElement.clientWidth + this.getScrollbarWidth()
      this.setMediaQuery({
        windowWidth: w,
        windowHeight: document.documentElement.clientHeight,
        wXS: w <= bootstrapMediaQuery.xs.max,
        wSM: w >= bootstrapMediaQuery.sm.min && w <= bootstrapMediaQuery.sm.max,
        wMD: w >= bootstrapMediaQuery.md.min && w <= bootstrapMediaQuery.md.max,
        wLG: w >= bootstrapMediaQuery.lg.min && w <= bootstrapMediaQuery.lg.max,
        wXL: w >= bootstrapMediaQuery.xl.min,
      })
    },
    getScrollbarWidth() {
      if (document.querySelectorAll('body')[0].style.overflow === 'hidden') {
        return 0
      }
      var outer = document.createElement('div')
      outer.style.visibility = 'hidden'
      outer.style.width = '100px'
      outer.style.msOverflowStyle = 'scrollbar' // needed for WinJS apps

      document.body.appendChild(outer)

      var widthNoScroll = outer.offsetWidth
      // force scrollbars
      outer.style.overflow = 'scroll'

      // add innerdiv
      var inner = document.createElement('div')
      inner.style.width = '100%'
      outer.appendChild(inner)

      var widthWithScroll = inner.offsetWidth

      // remove divs
      outer.parentNode.removeChild(outer)

      return widthNoScroll - widthWithScroll
    },
  },
  components: {
    FadeTransition,
  },
  computed: {
    ...mapGetters([
      'jumpmenuitems',
      'statusMobileMenu',
      'userInfo',
      'isScrollonTop',
      'mediaQuery',
      'menuOptions',
      'loadingBar',
    ]),
  },
  mixins: [FAMixin],
}
</script>
<style></style>
